import { CustomAttribTypes, OptionTypes, TableColumnTypes } from "pages/configs/configs";
import { COLUMN_TYPE } from "utils/constants";

export interface DemoUserTypes {
  Attributes: CustomAttribTypes[];
  Enabled: boolean;
  UserCreateDate: string;
  UserLastModifiedDate: string;
  UserStatus: string;
  Username: string;
  expirationDate: string;
}

export interface UserRequestType {
  rolename: string;
  username: string;
}

export interface setUserIsDisabledTypes {
  username: string;
  useraccount: string;
}

export interface DeviceListTypes {
  serialNumber: string;
  assigned: boolean;
}

export interface DemoUserAddTypes {
  username: string;
  groupname: string;
  name: string;
  phonenumber: string;
  email: string;
  role: string;
}

export interface ListRowTypes {
  createdTimeStamp: string;
  email: string;
  expire: string;
  name: string;
  org: string;
  role: string;
  enabled: boolean;
}

export interface DemoUserColumnTypes extends TableColumnTypes {
  format?: (value: any) => any;
  isSort?: boolean;
  filter?: boolean;
  type?: string;
  align: "center" | "left" | "right" | "inherit" | "justify" | undefined;
}

export const DEMO_USER_CONFIG: DemoUserAddTypes = {
  username: "",
  groupname: "Airgain-Demo",
  name: "",
  phonenumber: "+18580000000",
  email: "",
  role: "demouser",
};

export interface DemoDeviceConfigTypes {
  serialNumber: string;
  demoUser: string;
  action: string;
}

export const DEMO_DEVICE_CONFIG: DemoDeviceConfigTypes = {
  serialNumber: "",
  demoUser: "",
  action: "add",
};

export const DEMO_DEVICE_GRID_COLUMNS: any[] = [
  { id: "serialNumber", label: "Serial Number", type: COLUMN_TYPE.STRING },
  {
    id: "assigned",
    label: "Assigned",
    type: COLUMN_TYPE.STRING,
  },
];

export const DEMO_USERS_GRID_COLUMNS: any[] = [
  { id: "email", isSort: true, label: "Email", minWidth: 70, maxWidth: 70, type: COLUMN_TYPE.STRING },
  {
    id: "org",
    label: "Organization",
    isSort: true,
    minWidth: 100,
    maxWidth: 100,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "role",
    label: "Role",
    align: "center",
    isSort: true,
    minWidth: 70,
    maxWidth: 70,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "createdTimeStamp",
    label: "Created",
    isSort: true,
    minWidth: 100,
    maxWidth: 100,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "expirationDate",
    label: "Expiry",
    isSort: true,
    minWidth: 100,
    maxWidth: 100,
    type: COLUMN_TYPE.STRING,
  },
  {
    id: "extend",
    label: "Extend Expiry",
    align: "center",
    isSort: true,
    minWidth: 100,
    maxWidth: 100,
    type: COLUMN_TYPE.OPTION,
  },
  {
    id: "enabled",
    label: "Disable",
    align: "center",
    isSort: true,
    minWidth: 100,
    maxWidth: 100,
    type: COLUMN_TYPE.OPTION,
  },
  {
    id: "delete",
    label: "Delete",
    align: "center",
    isSort: true,
    minWidth: 100,
    maxWidth: 100,
    type: COLUMN_TYPE.OPTION,
  },
];

export const demoUserRowDefaults = {
  createdTimeStamp: "",
  email: "",
  expire: "",
  org: "",
  role: "",
};
